import styled, { css, keyframes } from 'styled-components';
import LoadingSpinner from '@carvana/loading-spinner';
import { Column } from '../Layout';

const ColumnStyles = css`
  display: flex;
  height: 56px;
  flex: 1;
`;

export const CancelWrapper = styled.div`
  ${ColumnStyles} margin-right: 13px;
`;

export const SaveChangesWrapper = styled(Column)`
  ${ColumnStyles};
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
`;

const color = (props: any) => keyframes`
  100%,
  0% {
    stroke: ${props.theme.carvana.white.primary};
  }
  40% {
    stroke: ${props.theme.carvana.white.primary};
  }
  66% {
    stroke: ${props.theme.carvana.white.primary};
  }
  80%,
  90% {
    stroke: ${props.theme.carvana.white.primary};
  }
`;

export const Spinner = styled(LoadingSpinner)`
  transform: scale(0.5);
  height: 56px;

  &:focus {
    border: none;
  }
  * {
    color: ${(props: any) => props.theme.carvana.white.primary};
  }

  circle {
    animation:
      ${dash} 1.5s ease-in-out infinite,
      ${(props: any) => color(props)} 6s ease-in-out infinite;
  }

  > div > svg {
    &::first-of-type {
      fill: ${(props: any) => props.theme.carvana.white.primary};
    }
  }
`;
